<template>
    <form @submit="submit" class="item-editor-form">

        <label for="season">{{ $t('departure.season') }}:</label>
        <seasonSelect v-if="action == 'new'" v-model="item.kausi" id="season"/>

        <label for="daytype">{{ $t('departure.daytype') }}:</label>
        <daytypeSelect v-if="action == 'new'" v-model="item.paivatyyppi" id="daytype"/>

        <b-form-group :label="$t('departure.departure_times')">
        <template v-for="(item, index ) in this.departures">
            <b-input-group v-bind:key="'group'+index" class="mb-3">
                <b-form-input v-bind:key="'text'+index" v-model="item.lahtoaika" type="text" placeholder="HH:mm" :formatter="timeFormatter" lazy-formatter></b-form-input>
                <b-form-timepicker v-model="item.lahtoaika" v-bind:key="'namekey'+index" v-bind:id="'name'+index" button-only right></b-form-timepicker>
            </b-input-group>
          </template>
        </b-form-group>

        <TableActionHeader v-on:newItem="onNewItem" :searchInput="false"></TableActionHeader> 

        <FormButtons
            @submit="submit" 
            :reset="false" 
            :remove="false" 
            :disableSubmit="loading" />

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

    </form>
</template>

<script>
import FormButtons from '@/components/Misc/FormButtons'
import daytypeSelect from '@/components/Timetable/DayTypeSelect'
import seasonSelect from '@/components/Timetable/SeasonSelect'
import moment from 'moment';

export default {
    components: {
        FormButtons, daytypeSelect, seasonSelect, 
    },
    props: {
        item: {
            required: true
        }, 
        action: { default: "new" },
        route:  { default: null },
        defaultPassingTime: { default: moment("00:00", "HH:mm").utcOffset(0).format("HH:mm") }
    },
    data() {
        return {
            departures: [],
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },
    created: function(){
        this.addDepartureTime(JSON.parse(JSON.stringify(this.item)));
    },
    computed: {
        formatItems() {
            let formattedDepartures = [];
            for( let dep of this.departures) {
                const newDep = { ...dep }
                newDep.paivatyyppi = this.item.paivatyyppi;
                newDep.kausi = this.item.kausi;
                
                if( dep.lahtoaika ) {
                    if( moment(dep.lahtoaika, "HH:mm", true).isValid() || moment(dep.lahtoaika, "HH:mm:ss", true).isValid() ) {
                        newDep.lahtoaika = moment(dep.lahtoaika, "HH:mm").utcOffset(0).format("YYYY-MM-DD[T]HH:mm:ss");
                    } else {
                        newDep.lahtoaika = this.defaultPassingTime;
                    }
                    formattedDepartures.push(newDep);
                }
            }            
            return formattedDepartures; 
        },
    },    
    watch: {
        item(){
            this.ok = this.error = this.loading = false;            
        } 
    },
    methods: {
        timeFormatter(value) {
            if( moment(value).isValid() )
                return moment(value).format("HH:mm")
            return value;
        },
        addDepartureTime(item) {
            item.lahtoaika = "";
            item.reitti = this.route;
            this.departures.push(item);        
        },
        formatTime(item) {
            let timeArray = item.lahtoaika.split("T")[1].split(":");                       
            let departureTime = parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);
            let hours = Math.floor(departureTime / 60);
            let minutes = departureTime - hours * 60;
            let timeStr = hours < 10 ? "0" + hours : hours;
            timeStr+= ":" + (minutes < 10 ? "0" + minutes : minutes);
            return timeStr; 
        },        
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
          
            this.$store.dispatch('timetable/saveDepartures' , this.formatItems).then(response => {
                this.ok = response.data.errorCode == 0;
                this.error = !this.ok;
            })
            .catch( () => { 
                this.error = true; 
            }) 
            .finally(() => {
                this.loading = false;
                this.$emit('refreshDepartures', this.route);
                this.departures = [];
                this.addDepartureTime(JSON.parse(JSON.stringify(this.item)));
            })
            
        },
        onNewItem() {
            this.addDepartureTime(JSON.parse(JSON.stringify(this.item)));
        },
    } 
}
</script>

